<div class="modal-headerTitle">
    {{announcement.StartDate | date: 'shortDate'}} - {{announcement.Title}}
</div>
<tyl-quill-text-only class="flex-content"
    [padding]="0"
    [html]="announcement.Announcement"
    ExternalLink></tyl-quill-text-only>
<div class="flex-footer">
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</div>
